import * as React from "react";
import { useApi } from "../../containers/ApiContainer";
import {
  HangarsStateContainer,
  useHangarsState,
} from "../../containers/HangarsStateContainer";
import { LocationsContainer } from "../../containers/LocationsStateContainer";
import {
  RampsStateContainer,
  useRampsState,
} from "../../containers/RampsStateContainer";
import { useTenants } from "../../hooks/useTenants";
import { Tenant } from "../../types";
import { TenantsPresenter } from "./TenantsPresenter";
import { TenantsSkeleton } from "./TenantsSkeleton";

// Inner component that uses the state hooks after providers are rendered
const TenantsContent: React.FC<{
  filter: string;
  setFilter: (text: string) => void;
  editTenantId: string;
  setEditTenantId: (id: string) => void;
}> = ({ filter, setFilter, editTenantId, setEditTenantId }) => {
  const { postgrest } = useApi();
  const { tenants, setTenant, setTenants, ready: tenantsReady } = useTenants();

  // Now we can safely use these hooks because their providers are already rendered
  const { ready: hangarsReady } = useHangarsState();
  const { ready: rampsReady } = useRampsState();

  // All data is ready when hangars, ramps, and tenants are all loaded
  const allDataReady = hangarsReady && rampsReady && tenantsReady;

  const deleteTenant = React.useCallback(
    async (tenant: Tenant) => {
      await postgrest.from("tenant").delete().eq("entity_id", tenant.entity_id);
      setTenants(tenants.filter((t) => t.entity_id !== tenant.entity_id));
    },
    [tenants]
  );

  // Show skeleton while data is loading
  if (!allDataReady) {
    return <TenantsSkeleton />;
  }

  return (
    <TenantsPresenter
      filter={filter}
      tenants={tenants}
      setTenant={setTenant}
      deleteTenant={deleteTenant}
      setFilter={setFilter}
      editTenantId={editTenantId}
      setEditTenantId={setEditTenantId}
    />
  );
};

type Props = {};

export const Tenants: React.FC<Props> = () => {
  const [filter, setFilter] = React.useState<string>("");
  const [editTenantId, setEditTenantId] = React.useState<string>("");

  return (
    <RampsStateContainer isReference={false}>
      <HangarsStateContainer isReference={false}>
        <LocationsContainer>
          <TenantsContent
            filter={filter}
            setFilter={setFilter}
            editTenantId={editTenantId}
            setEditTenantId={setEditTenantId}
          />
        </LocationsContainer>
      </HangarsStateContainer>
    </RampsStateContainer>
  );
};
